export default {
  emailReg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  mailReg:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|([A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+)$/,
  passwordReg: /(?![0-9]+$)(?![a-zA-Z]+$){6,20}/,
  // 匹配这些中文标点符号 。 ！ ， 、（ ）
  simpleMarks: /[\u3002\uff01\uff0c\u3001\uff08\uff09]/,
  // 整数或小数价格,小数点前保留8位,小数点后保留2位,且不可为0
  regNum: /(^[1-9][0-9]{0,7}$)|(^((0\.0[1-9]$)|(^0\.[1-9]\d?)$)|(^[1-9][0-9]{0,7}\.\d{1,2})$)/,
  // 大于0的整数或小数
  regNums: /(^[1-9][0-9]{0,}$)|(^((0\.0[1-9]$)|(^0\.[1-9]\d?)$)|(^[1-9][0-9]{0,}\.\d{1,})$)/,
  // 只允许中文、英文、空格、数字
  userName:
    /^[A-Za-z\u4e00-\u9fa50-9][A-Za-z\u4e00-\u9fa50-9|\s?]{0,28}[A-Za-z\u4e00-\u9fa50-9]$|^[[A-Za-z\u4e00-\u9fa50-9]$/,
  // 数字或字母
  numOrLetter: /^[A-Za-z0-9]+$/,
  // 字母
  letter: /^[a-zA-Z ]+$/,
  // 网址URL
  url: /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/,
  // 是否为纯数字
  nonNum:
    /^[0-9 `~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、’¥「」｜\n]+$/,
  //快递单号校验
  transportNum: /^(PI|PO|PD|PR)[0-9]{11}$/i,
  // 匹配中文‘
  hasChinese: /[\u4e00-\u9fa5]+/,
  // 检验是否为url
  isURLReg:
    /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/,
  // 整数正则
  isIntReg: /^[1-9]\d*$/,
}

export function getStrUrl(s) {
  var reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
  s = s.match(reg)
  return s && s.length ? s[0] : null
}
